import React from "react";

// Components
import Layout from "../v1/layout";
import MainRoutes from "../v1/services/navigation/route/main";

const App = () => {
  const [collapsed, setCollapsed] = React.useState(true);

  const items = { collapsed, setCollapsed };

  return (
    <>
      <Layout {...items}>
        <MainRoutes {...items} />
      </Layout>
    </>
  );
};

export default React.memo(App);
